<div class="filters-section" [formGroup]="form">
  <app-filters-container
  [label]="'BUTTONS.FILTERS' | translate" 
  (searchEventEmitter)="onSearch()"
  (resetEventEmitter)="onReset()">
  <div class="filters-container">
    <app-input-field
      [placeholder]="'PLACEHOLDERS.USERNAME_EXAMPLE' | translate" 
      [label]="'PLACEHOLDERS.USER_NAME' | translate" 
      formControlName="userName">
    </app-input-field>
    <app-input-field 
      [placeholder]="'PLACEHOLDERS.NAME_EXAMPLE' | translate" 
      [label]="'PLACEHOLDERS.NAME' | translate" 
      formControlName="name">
    </app-input-field>
    <app-input-field 
      [placeholder]="'PLACEHOLDERS.EMAIL_EXAMPLE' | translate" 
      [label]="'PLACEHOLDERS.EMAIL' | translate" 
      formControlName="email">
    </app-input-field>
    <app-date-range 
      [label]="'PLACEHOLDERS.DATE' | translate" 
      formControlName="dateRange">
    </app-date-range>
  </div>
</app-filters-container>
</div>
